import { Object3D } from 'three'

let activeRotatorGizmoRoot: Object3D | null = null

export function setActiveRotatorGizmoRoot(root: Object3D | null) {
  activeRotatorGizmoRoot = root
}

export function getActiveRotatorGizmoRoot(): Object3D | null {
  return activeRotatorGizmoRoot
}
